<template>
  <div class="header__user" v-click-outside="handleClickOutside">
    <div class="header__user-logo">
      <UserLogo />
    </div>
    <div class="header__user-info">
      <div class="header__user-name">{{ user.name || "User name" }}</div>
      <div class="header__user-role">{{ userGroup }}</div>
    </div>
    <div @click="handleOpenUserMenu" :class="['header__user-button', userMenu && 'active']">
      <SelectIcon />
    </div>
    <ul v-if="userMenu" class="header__user-list">
      <li
        v-for="code in locales"
        :key="code"
        @click="handleSetLocale(code)"
        :class="[
          'header__user-list-item',
          'header__user-list-item--locale',
          code === $i18n.locale && 'active',
        ]"
      >
        {{ code.toUpperCase() }}
      </li>
      <li @click="handleLogout" class="header__user-list-item">{{ $t("header.logout") }}</li>
    </ul>
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";

import UserLogo from "../../assets/images/logo/user-logo.svg";
import SelectIcon from "../../assets/images/icons/select-icon-small.svg";
import { getStoredUserInfo } from "../../helpers/userAuth";
import { SUPPORTED_LOCALES, setLocale } from "../../plugins/i18n";
export default {
  name: "HeaderName",
  data() {
    return {
      userMenu: false,
      user: {},
      locales: SUPPORTED_LOCALES,
    };
  },
  directives: {
    ClickOutside,
  },
  components: {
    UserLogo,
    SelectIcon,
  },
  mounted() {
    if (getStoredUserInfo()) {
      this.user = getStoredUserInfo();
    }
  },
  computed: {
    userGroup() {
      if (this.user.groups) {
        return this.user.groups[0].name;
      } else {
        return "";
      }
    },
  },
  methods: {
    handleOpenUserMenu() {
      this.userMenu = !this.userMenu;
    },
    handleClickOutside() {
      this.userMenu = false;
    },
    handleLogout() {
      this.$store.dispatch("users/logout");
    },
    // Выбор языка живёт в localStorage этого браузера: в профиль не пишем,
    // чтобы не трогать API и роли.
    handleSetLocale(code) {
      setLocale(code);
      this.userMenu = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  &__user {
    position: relative;
    display: flex;
    align-items: center;
    padding-right: 100px;
  }

  &__user-list {
    width: calc(100% + 11px);
    list-style: none;
    position: absolute;
    top: 120%;
    left: -11px;
    background: $g-color-white;
    z-index: 100001;
    box-shadow: 2px 2px 2px 1px rgba(0, 0, 0, 0.2);
    border: 1px solid $mainDisabled;
    border-radius: 5px;
  }

  &__user-list-item {
    padding: 5px 15px;
    color: $mainColor;
    font-size: 18px;
    font-weight: bold;
    cursor: pointer;

    &:hover {
      background: $coffee;
      color: $g-color-white;
    }
  }

  &__user-list-item--locale {
    font-size: 14px;

    &.active {
      background: $mainDisabled;
    }
  }

  &__user-logo {
    width: 40px;
    height: 40px;
    margin-right: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    background: $mainDisabled;

    svg {
      width: 30px;
      height: 30px;
    }
  }

  &__user-info {
    padding-top: 5px;
  }

  &__user-name {
    padding-bottom: 2px;
    color: $g-color-white;
    font-size: 14px;
  }

  &__user-role {
    color: $g-color-white;
    font-size: 12px;
    font-weight: bold;
  }

  &__user-button {
    margin-top: 4px;
    margin-left: 10px;
    cursor: pointer;

    svg {
      path {
        fill: $g-color-white;
      }
    }

    &.active {
      transform: rotate(180deg);
    }
  }
}

@media (max-width: 1500px) {
  .header {
    &__user {
      padding-right: 0;
    }
  }
}
</style>
